import React from "react"
import { useParams } from "react-router-dom"

// api
// "activity" model
import { useGetActivityTeam } from "api/hooks/activities/useActivityTeamApi"
// "request" model
import { useGetRequestTeam } from "api/hooks/requests/useRequestTeam"

// utils
import useTeam from "utilities/useTeam"

const useWorkflowTeam = () => {
  const { studyId, activityId, requestId } = useParams()

  // "activity"
  const { data: activityTeam } = useGetActivityTeam(studyId, activityId)

  // "request"
  const { data: requestTeam } = useGetRequestTeam(requestId, { enabled: !!requestId })

  // both models
  const { teamUsersToStr, teamUsersToIds } = useTeam() // hook not necessary for pure function

  const team = activityId ? activityTeam : requestTeam
  const teamOptions = React.useMemo(() => {
    if (!team) return []
    const map = {}
    const options = []

    team.forEach((role) => {
      if (role?.members) {
        role.members.forEach((member) => {
          if (!map[member.person_id]) {
            map[member.person_id] = {
              name: member.person_fullname,
              roles: [role.role_name],
            }
          } else {
            map[member.person_id].roles.push(role.role_name)
          }
        })
      }
    })

    Object.keys(map).forEach((id) => {
      let userRoles = map[id].roles.join("/")
      options.push({
        label: `${map[id].name} (${userRoles})`,
        value: Number(id),
      })
    })

    return options
  }, [team])
  const teamIds = React.useMemo(() => team && teamUsersToIds(team), [team])

  return {
    teamOptions,
    teamIds,
  }
}

export default useWorkflowTeam
